module.exports = __webpack_public_path__ + "img/video-confirm.27c33dcf.png";